import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

import { BonusVO } from "../../../gamevo/BonusVO";

export class Poker2LoginBonusDialogProperties extends BasicDialogProperties {
    public bonusVOs: BonusVO[];
    public loginDays: number = 0;

    constructor(daysLoggedIn: number, bonusVOs: BonusVO[]) {
        super();
        this.loginDays = daysLoggedIn;
        this.bonusVOs = bonusVOs;
    }
}
